var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"audio-tracker-recorder--counter"},_vm._l((_vm.items),function(item){return _c('div',{staticClass:"counter-item flex-row align-center center",class:{ 'start': item.isStart }},[_vm._v(_vm._s(item.value))])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }